var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left_section"},[_c('BottomBack',{attrs:{"borderStyle":{transform: 'scaleX(-1)',right: 0}}},[_c('div',{staticClass:"main"},[_c('SendOutWater'),_c('Inlet'),_c('OutWaterMonitor')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }